import api from './api';

const documentService = {
  /**
   * Obtener todos los documentos
   */
  getDocuments: async (params = {}) => {
    try {
      const response = await api.get('/documents', { params });
      return response.data;
    } catch (error) {
      console.error('Error al obtener documentos:', error);
      throw error;
    }
  },

  /**
   * Obtener un documento por ID
   */
  getDocument: async (id) => {
    try {
      const response = await api.get(`/documents/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener documento:', error);
      throw error;
    }
  },

  /**
   * Crear un nuevo documento
   */
  createDocument: async (data) => {
    try {
      const response = await api.post('/documents', data);
      return response.data;
    } catch (error) {
      console.error('Error al crear documento:', error);
      throw error;
    }
  },

  /**
   * Actualizar un documento
   */
  updateDocument: async (id, data) => {
    try {
      const response = await api.put(`/documents/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Error al actualizar documento:', error);
      throw error;
    }
  },

  /**
   * Eliminar un documento
   */
  deleteDocument: async (id, params = {}) => {
    try {
      const response = await api.delete(`/documents/${id}`, { params });
      return response.data;
    } catch (error) {
      console.error('Error al eliminar documento:', error);
      throw error;
    }
  },

  /**
   * Obtener órdenes de compra pendientes (para agregar a documento)
   */
  getPendingPurchaseOrders: async (params = {}) => {
    try {
      const response = await api.get('/purchase-orders', { 
        params: { ...params, status: 'issued' } 
      });
      return response.data;
    } catch (error) {
      console.error('Error al obtener órdenes de compra pendientes:', error);
      throw error;
    }
  },

  /**
   * Obtener órdenes de servicio pendientes (para agregar a documento)
   */
  getPendingServiceOrders: async (params = {}) => {
    try {
      const response = await api.get('/service-orders', { 
        params: { ...params, status: 'issued' } 
      });
      return response.data;
    } catch (error) {
      console.error('Error al obtener órdenes de servicio pendientes:', error);
      throw error;
    }
  },

  /**
   * Obtener guías de entrada pendientes (para agregar a documento)
   */
  getPendingEntryGuides: async (params = {}) => {
    try {
      const response = await api.get('/entry-guides/pending-entry-guides', { params });
      return response.data;
    } catch (error) {
      console.error('Error al obtener guías de entrada pendientes:', error);
      throw error;
    }
  },

  /**
   * Obtener servicios continuos cerrados (para agregar a documento).
   * for_document_selector=true devuelve todos los cerrados para mostrarlos en el modal.
   */
  getClosedContinuousServices: async (params = {}) => {
    try {
      const response = await api.get('/continuous-services', { 
        params: { ...params, status: 'closed', for_document_selector: true } 
      });
      return response.data;
    } catch (error) {
      console.error('Error al obtener servicios continuos cerrados:', error);
      throw error;
    }
  },

  /**
   * Catálogos livianos del formulario de documentos (proveedores, servicios, unidades, etc.).
   */
  getFormData: async () => {
    try {
      const response = await api.get('/documents/form-data');
      return response.data;
    } catch (error) {
      console.error('Error al obtener datos del formulario de documentos:', error);
      throw error;
    }
  },

  /**
   * Referencias pendientes para el modal "Seleccionar referencias".
   */
  getFormReferences: async (params = {}) => {
    try {
      const response = await api.get('/documents/form-references', { params });
      return response.data;
    } catch (error) {
      console.error('Error al obtener referencias del formulario de documentos:', error);
      throw error;
    }
  },
};

export default documentService;


